<template>
  <pagination-impl
    :value="effectiveValue"
    :records="records"
    :per-page="perPage"
    :options="options"
    v-on="$listeners"
  />
</template>

<script>
// vue-tables-3's built-in pagination integration renders <pagination :page="..."> (its
// older, expected API), while the installed vue-pagination-2 requires a `value` prop
// for v-model instead. That mismatch leaves `value` undefined, which cascades into
// `RangeError: Invalid array length` inside vue-pagination-2 on every table page.
// This wrapper accepts either prop name and forwards whichever is set, without
// touching either dependency.
import PaginationImpl from 'vue-pagination-2'

export default {
  name: 'PaginationCompat',
  components: { PaginationImpl },
  props: {
    value: { type: Number, default: undefined },
    page: { type: Number, default: undefined },
    records: { type: Number, required: true },
    perPage: { type: Number, default: 25 },
    options: { type: Object, default: undefined },
  },
  computed: {
    effectiveValue() {
      const candidate = this.value !== undefined ? this.value : this.page
      return candidate > 0 ? candidate : 1
    },
  },
}
</script>
